module.exports = function getResource(label, vars = []) {
    let resources = {
        hours: 'Hours',
        openTodayUntil: 'Open today until'
    };

    return resources[label];
};
